import Fetcher from "../../../services/fetcher";
import settings from "../../../settings";

const publishBestOf = (bestOfId: any) => {
  return Fetcher.post(settings.bestOfApi + "/publish", JSON.stringify({
    bestOfId: bestOfId,
    publishDate: new Date().getTime(),
  }));
};

export default publishBestOf;
